module.exports = __webpack_public_path__ + "static/img/icon_layout.a2469f9.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/icon_layout.svg
// module id = 1aGN
// module chunks = 1